import React, { useState, useEffect } from 'react';
import html2canvas from 'html2canvas';
import { getUser } from '../../utils/Common';
import { dateFormatConDiaYHoraShort, getDate } from '../../utils/DateFunctions'
import jsPDF from 'jspdf';

const ReporteSemillaPDF = (p) => {
    const width = 1100;
    const height = width * 1.294117647058824;
    const semana_inicio = p.semana_inicio ?? "No diponible";
    const semana_fin = p.semana_fin ?? "No disponible";
    const docs_by_page = 63;
    const docs_by_page_compacto = 33;
    const [compacto, setcompacto] = useState(false);

    const [reporte, setreporte] = useState([]);

    useEffect(() => {
        make_report();
    }, []);

    const make_report = (compactoCP = compacto) => {
        let reps = [];
        let hoja = [];

        let data = [...(p.data ?? [])];
        let registros = 0;
        let completo = 0, incompleto = 0;
        let byPage = compactoCP ? docs_by_page_compacto : docs_by_page;
        for (let i = 0; i < data.length; i++) {
            let dt = data[i];
            completo += dt.completo_semillas;
            incompleto += dt.incompletos_semillas;
            registros += (compactoCP ? 1 : dt.registros.length + 2);
            if (registros < byPage) hoja.push(dt);
            else {
                reps.push([...hoja]);
                hoja = [];
                registros = (compactoCP ? 1 : dt.registros.length + 1.5);
            }
        }

        if (hoja.length > 0) reps.push(hoja);
        console.log('reps', reps);
        setreporte(reps);
    }

    const copactar = () => {
        let newCompacto = !compacto;
        setcompacto(newCompacto);
        make_report(newCompacto);
    }

    const createPDF = async () => {
        if (p.data.length === 0) return;
        p.loader(true);
        const doc = new jsPDF({
            orientation: 'portrait', // 'portrait' para retrato, 'landscape' para apaisado
            unit: 'mm',
            format: [215.9, 279.4], // [ancho, alto]
        });

        for (let i = 0; i < reporte.length; i++) {
            let id = "hojaArr" + i;
            const componentRef = document.getElementById(id); // Reemplaza con el ID de tu componente

            if (componentRef) {
                const canvas = await html2canvas(componentRef, { scale: 1.5 });
                const imgData = canvas.toDataURL('image/png');

                // Calcula el ancho y el alto de la imagen en el PDF
                const imgWidth = 215.9; // Ancho de la página en mm (A4)
                const imgHeight = 279.4;

                // Agrega la imagen como una nueva página al PDF
                if (i > 0) {
                    doc.addPage();
                }
                doc.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
            }
        }

        // Guarda el PDF como un solo archivo
        doc.save('REP_EJEC_PLAN_' + p.data[0].semanainicio);
        p.loader(false);
    };

    const columnaTotales = (json) => {
        let planeado = 0;
        let ejecutado = 0;
        for (let i = 0; i < 6; i++) {
            planeado += json.plan[i];
            ejecutado += json.ejecutado[i];
        }
        return (
            <div className={`text-center text-bold border-start border-dark p-0 m-0`} style={{ width: `${80 / 7}%` }}>
                <div className='row justify-content-evenly w-100 m-0 p-0 '>
                    <div className='w-50 text-center m-0 p-0 border-end'>{planeado}</div>
                    <div className='w-50 text-center m-0 p-0'>{ejecutado}</div>
                </div>
            </div>
        );
    }

    return (
        <div className='vw-100 vh-100 p-0 m-0 blur-m bg-white3' style={{ overflowY: "auto", zIndex: 99, position: "fixed", top: 0, left: 0 }}>
            <div className='row justify-content-evenly m-0 p-0 w-100 mt-2' style={{ position: "sticky", top: 0, zIndex: 2 }}>
                <div className='col-auto  text-center'>
                    <button className='btn btn-danger mt-2 shadow p-0  round-xxl bw-200' onClick={p?.close ?? (() => { })} >Cerrar</button>
                </div>
                <div className='col-auto mt-2 text-center'>
                    <button className='btn btn-light p-0 shadow round-xxl scale-025 border text-bold bw-200' onClick={copactar} >Cambiar a version {compacto ? 'extendida' : 'Compacta'}</button>
                </div>
                <div className='col-auto mt-2 text-center'>
                    <button className='btn btn-warning shadow round-xxl scale-continue-05 text-bold p-0 bw-200' onClick={createPDF} >Descargar {reporte.length} hoja(s)</button>
                </div>
                <div className='w-100 m-0 p-0'></div>
                {reporte.map((hoja, k) => <div key={"hoja aaa" + k} id={"hojaArr" + k} className={'bg-white text-center mt-5 mb-5 p-3 dosis' + (hoja.length === docs_by_page ? " contenedor" : "")}
                    style={{ minWidth: width, maxWidth: width, minHeight: height, maxHeight: height, border: "black solid 2px" }}>
                    <div className='row justify-content-evenly m-0 p-0 w-100'>
                        <div className='col-lg-12 text-end text-s text-300 p-0 m-0'>
                            <span className='me-2 text-bold'>Reporte de semilla, semanas incluidas:{semana_inicio} - {semana_fin}</span>
                            <span className='ms-3 me-3 text-bold opacity-70'>Generado por:{getUser().nombre ?? "No logueado"}</span>
                            Fecha de creación:{dateFormatConDiaYHoraShort(getDate())}
                        </div>
                        {hoja.map((report, i) => <React.Fragment key={k + 'bloque' + i}>
                            <div className='w-100 m-0 p-0 mt-3 border-bottom border-dark' />
                            <div className='text-m text-bold border text-start' style={{ width: '40%' }}>
                                {report.bloque}
                            </div>
                            <div className='text-l border contenedor text-s' style={{ width: '20%' }}>
                                <div className='w-100 text-s text-start'>
                                    FALTANTE:<span className='text-bold ms-1'>{(report.incompletos_semillas).toLocaleString('en-US')}</span>
                                </div>
                            </div>
                            <div className='text-l border contenedor text-s' style={{ width: '20%' }}>
                                <div className='w-100 text-s text-start'>EXISTENCIA:<span className='text-bold ms-1'>{report.completo_semillas.toLocaleString('en-US')}</span></div>
                            </div>
                            <div className='text-l text-bold border contenedor text-s' style={{ width: '20%' }}>
                                <div className='w-100 text-s text-start'>
                                    AVANCE:<span className='text-bold ms-1'>{
                                        Math.round((report.incompletos_semillas + report.completo_semillas) > 0 ?
                                            ((report.completo_semillas / (report.incompletos_semillas + report.completo_semillas)) * 100) : 0)}%
                                    </span>
                                </div>
                            </div>
                            {
                                !compacto && report.registros.map((registro, j) => <div key={k + 'bloque' + i + 'registro' + j}
                                    className='w-100 m-0 p-0 border-bottom opacity-80'>
                                    <div className='row justify-content-start p-0 m-0'>
                                        <div className='col-auto'>
                                            {registro.completo === 'NO' ? '❌' : '✅'}
                                        </div>
                                        <div className='w-20 p-0 m-0 text-start'>
                                            Semana:<span className='ms-1 text-bold'>{registro.semana_siembra}</span>
                                        </div>
                                        <div className='w-20 p-0 m-0 text-start'>
                                            Semillas:<span className='ms-1 text-bold'>{registro.semillas.toLocaleString('en-US')}</span>
                                        </div>
                                        <div className='w-30 p-0 m-0 text-start'>
                                            Usuario:<span className='ms-1 text-bold'>{registro.nombre ?? 'Sin completar'}</span>
                                        </div>
                                    </div>
                                </div>)
                            }
                        </React.Fragment>
                        )}

                    </div>
                </div>)}
            </div >
        </div >
    )
}

export default ReporteSemillaPDF;